import { ReactComponent } from "./blue-check-fill.svg";

interface Props {
  style?: React.CSSProperties;
}

const BlueCheckFillIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default BlueCheckFillIcon;
